import { ErrorsAlert } from "./ValidationErrors";

export function ServerValidationErrors(props: { localisations: any; title: string; error: Error | null }) {
    if (!(props.error instanceof BadRequestError)) {
        return null;
    }

    const errorData = props.error.data?.errors;
    if (!errorData) return null;

    const errors = Object.keys(errorData).flatMap((k) => errorData[k].map((v: string) => ({ field: k, code: v })));
    if (!errors.length) return null;

    function localise(loc: any, field: string, code: string): string {
        const fallback = `Missing localisation: ${field}.${code}`;

        let dotPos = field.indexOf(".");
        if (dotPos > -1) {
            field = field.substr(dotPos + 1);
        }

        if (!loc) return fallback;
        if (!loc[field]) return fallback;
        return loc[field][code] || loc[field].default || fallback;
    }
    const localisedMessages = errors.map((e) => localise(props.localisations, e.field, e.code));

    return <ErrorsAlert style={{ marginBottom: 10 }} title={props.title} messages={localisedMessages} />;
}

export class HttpError extends Error {
    status: number;
    constructor(status: number, message?: string) {
        super(message);
        this.status = status;
    }
}

export class ForbiddenError extends HttpError {}

export type ValidationFailuresResponse = {
    type: "https://tools.ietf.org/html/rfc7231#section-6.5.1";
    title: string;
    status: number;
    detail: string;
    instance: string;
    errors: Record<string, string[]>;
};

export class BadRequestError extends HttpError {
    data: ValidationFailuresResponse | undefined;
    constructor(status: number, message?: string, data?: ValidationFailuresResponse) {
        super(status, message);
        this.data = data;
    }
}

export type FileNameConflictResponse = {
    type: string;
    title: string;
    status: number;
    detail: string;
    lastStockTransferImport: LastStockTransferImport;
};

export type LastStockTransferImport = {
    completedAtDateTime: Date | null;
    createdDateTime: Date | null;
    fileName: string;
    outcomeStatus: string | null;
};
